import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Aucun groupe de modificateurs. Créez-en un.',
  fields: {
    name: 'Nom',
    external_id: 'Réf. {{integration}}',
    prices: 'Prix',
    available: 'Disponible',
    status: 'Statut',
    statuses: {
      good: 'Bon',
      bad: 'Mauvais',
      medium: 'Moyen',
    },
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'À emporter',
    [ORDER_METHODS.delivery]: 'Livraison',
    [ORDER_METHODS.room_service]: 'Service en salle/table',
  },
  labels: {
    visible: 'Visible dans le menu',
    hidden: 'Tout masqué',
  },
  buttons: {
    add_modifier: 'Ajouter un modificateur',
    delete_modifier_one: 'Supprimer le modificateur',
    delete_modifier_other: 'Supprimer les modificateurs',
    show_modifier_group: 'Afficher le groupe de modificateurs',
    close_modifier_group: 'Fermer le groupe de modificateurs',
    edit: 'Modifier',
    duplicate: 'Dupliquer',
    history: 'Historique',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Échec de la duplication du groupe de modificateurs',
    modifier_group_duplicated_successfully: 'Groupe de modificateurs dupliqué avec succès',
    failed_to_duplicate_modifier: 'Échec de la duplication du modificateur',
    modifier_duplicated_successfully: 'Modificateur dupliqué avec succès',
  },
};
